module.exports = __webpack_public_path__ + "static/media/lisa.d254a76a.png";